/* @flow */
import * as React from 'react';
import { observer } from 'mobx-react';
import Moment from 'react-moment';

import { translate } from 'react-i18next';

import type { TranslatorProps } from 'react-i18next';

import type TypeForm from 'forms/_.extend';

import ElectroSelectWithOther from 'forms/components/inputs/ElectroSelectWithOther/ElectroSelectWithOther';
import ElectroCheckList from 'forms/components/inputs/ElectroCheckList/ElectroCheckList';
import ActionDrawerFormButtons from 'views/ActionDrawer/components/ActionDrawerFormButtons/ActionDrawerFormButtons';
import ActionDrawerBlock from 'views/ActionDrawer/components/ActionDrawerBlock/ActionDrawerBlock';
import ActionDrawerTable from 'views/ActionDrawer/components/ActionDrawerTable/ActionDrawerTable';

import styles from '../../../../ActionDrawer.module.scss';

type TypeProps = {
  t: TranslatorProps,
  asset: Object,
  form: TypeForm,
};

@translate()
@observer
export default class RemoveAssetFromProjectForm extends React.Component<*> {
  render(): React.Node {
    const { t, asset, form }: TypeProps = this.props;

    let details: Array<*> = [
      [t('general:assets.labels.number'), asset.asset_number],
      [t('general:manufacturer'), asset.manufacturer],
      [t('general:model'), asset.model],
      [t('general:labels.serial_number'), asset.serial_number],
    ];

    if (asset.contract) {
      details = [[t('general:trading_account'), asset.contract.company_name]].concat(details);
    }

    const project: Array<*> = [
      [t('general:projects.labels.name'), asset.project.name],
      [t('general:projects.labels.code'), asset.project.code],
      [
        t('general:labels.start_date'),
        <Moment key="start_date" date={asset.project.start_date.date} format="MMMM DD, YYYY" />,
      ],
      [
        t('general:labels.end_date'),
        <Moment key="end_date" date={asset.project.end_date.date} format="MMMM DD, YYYY" />,
      ],
      [t('general:cost_center'), asset.project.costcenter_name],
    ];

    return (
      <React.Fragment>
        <div className={styles['action-drawer-content']}>
          <ActionDrawerBlock
            divider={true}
            gutters={true}
            heading={t('general:assets.labels.details')}
          >
            <ActionDrawerTable data={details} />
          </ActionDrawerBlock>
          <ActionDrawerBlock
            divider={true}
            gutters={true}
            heading={t('general:projects.labels.details')}
          >
            <ActionDrawerTable data={project} />
          </ActionDrawerBlock>
          <ActionDrawerBlock gutters={true} heading={form.$('removeAssetReason').label}>
            <ElectroSelectWithOther
              field={form.$('removeAssetReason.reason')}
              otherHeading={`${t('general:reasons.provide_reason')} *`}
            />
          </ActionDrawerBlock>
        </div>
        <ActionDrawerFormButtons form={form} submitTxt={t('general:actions.remove_from_project')} />
      </React.Fragment>
    );
  }
}
